import { Injectable } from '@angular/core';
import { compress, decompress } from 'lz-string';
@Injectable({
  providedIn: 'root'
})
export class CompressionServiceService {

  constructor() { }

  compressString(data: string): string {
    return compress(data);
  }
  // compressObject(data: any): string {
  //   return compress(JSON.stringify(data));
  // }

  decompressString(compressed: string): string|null {
    return decompress(compressed);
  }
  // decompressObject(compressed: string): any {
  //   return JSON.parse(decompress(compressed));
  // }
}
